import { BodyShort } from "@digital-services-gard-as/anchor-react";
import { UploadIcon, DocumentIcon, CheckmarkCircleIcon } from "@digital-services-gard-as/anchor-icons";
import { Flex, Separator } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Fragment } from "react";

export const UploadInfoBox = () => {
    const { t } = useTranslation("claimsInvoicesOverview");

    const items = [
        {
            icon: <UploadIcon />,
            title: t("uploadInfoBox.uploadInvoice.title"),
            description: t("uploadInfoBox.uploadInvoice.description")
        },
        {
            icon: <DocumentIcon />,
            title: t("uploadInfoBox.reviewDetails.title"),
            description: t("uploadInfoBox.reviewDetails.description")
        },
        {
            icon: <CheckmarkCircleIcon />,
            title: t("uploadInfoBox.submitInvoice.title"),
            description: t("uploadInfoBox.submitInvoice.description")
        }
    ];

    return (
        <Flex
            flexDir="column"
            bg="anchor.white"
            w="full"
            h="full"
            p="1.5rem"
            gap="1.5rem"
            borderRadius="lg"
            boxShadow="sm"
        >
            <BodyShort size="lg" weight="bold">
                {t("uploadInfoBox.title")}
            </BodyShort>
            <Flex flexDir="column" gap="1rem">
                {items.map((item, index) => (
                    <Fragment key={item.title}>
                        <UploadInfoBoxItem icon={item.icon} title={item.title} description={item.description} />
                        {index < items.length - 1 && <Separator />}
                    </Fragment>
                ))}
            </Flex>
        </Flex>
    );
};

type UploadInfoBoxItemProps = {
    icon: React.ReactNode;
    title: string;
    description: string;
};
const UploadInfoBoxItem = ({ icon, title, description }: UploadInfoBoxItemProps) => {
    return (
        <Flex alignItems="center" gap="1rem">
            <Flex
                alignItems="center"
                bg="anchor.navy.50"
                borderRadius="50%"
                fontSize="1rem"
                justifyContent="center"
                minH="2.5rem"
                minW="2.5rem"
            >
                {icon}
            </Flex>
            <Flex flexDir="column" gap="0.25rem">
                <BodyShort weight="medium">{title}</BodyShort>
                <BodyShort size="sm">{description}</BodyShort>
            </Flex>
        </Flex>
    );
};
